import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import api from "../../../api/api";
import { QUERY_ADMIN_DASHBOARD_COMPANY_SETTINGS_KEY } from "../../../api/queryKeys";
import {
  QueryAdminCompanySettingsResponse,
  MutationAdminCompanySettingsRequestBody,
} from "../../../types";

const saveSettings = (data: MutationAdminCompanySettingsRequestBody) =>
  api
    .patch(QUERY_ADMIN_DASHBOARD_COMPANY_SETTINGS_KEY, data)
    .then((res) => res.data);

export default function useSaveCompanySettings() {
  const queryClient = useQueryClient();
  return useMutation<
    QueryAdminCompanySettingsResponse,
    any,
    MutationAdminCompanySettingsRequestBody
  >(saveSettings, {
    onSuccess: (data) => {
      queryClient.refetchQueries([QUERY_ADMIN_DASHBOARD_COMPANY_SETTINGS_KEY]);
      toast.success("Settings successfully saved");
    },
  });
}
